// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum DevType {
  Escalator = 0,
  Elevator = 1,
  Bot = 2,
  Gpio = 3,
  Relay = 4,
  Diligent = 5
}
